// CostSummary.tsx
import React from 'react';

interface CostSummaryProps {
  title: string;
  // subtotal があれば月額費用表示、なければ insurances を表示する
  subtotal?: number;
  insurances: number[];
}

export const CostSummary: React.FC<CostSummaryProps> = ({
  title,
  subtotal,
  insurances,
}) => {
  // URLから言語を判定（'ja' が含まれていれば日本語）
  const lang =
    typeof window !== 'undefined' &&
    (window.location.href.includes('/ja') ||
      window.location.href.includes('/jp'))
      ? 'ja'
      : 'en';

  // ラベル
  const subtotalLabel = lang === 'ja' ? '小計' : 'Subtotal';
  const grandTotalLabel = lang === 'ja' ? '合計' : 'Grand Total';

  // 「insurances 配列の 1つ目は初回登録料、2つ目はクリーニング費用」とする
  // これ以上の要素があれば「その他費用 / Other Fee」として表示
  const insuranceLabels = [
    lang === 'ja' ? '初回登録料' : 'InitialFee',
    lang === 'ja' ? '退去時クリーニング費用' : 'CleaningFee',
  ];

  // どちらを表示するかの判定
  const showSubtotal = insurances.length === 0; // insurances が空なら subtotal を表示
  const showInsurances = insurances.length > 0; // insurances があればそれを表示

  // grandTotal の計算
  const grandTotal = showSubtotal
    ? (subtotal ?? 0)
    : insurances.reduce((acc, curr) => acc + curr, 0);

  return (
    <div className="border border-black py-2 px-3 bg-cGray text-xs">
      <h3 className="text-xl mb-6">{title}</h3>

      {/* --- subtotal があれば表示（insurances が空のとき） --- */}
      {showSubtotal && (
        <div className="grid grid-cols-3 mb-1">
          <span>{subtotalLabel}:</span>
          <span className="text-center">¥</span>
          <span className="text-right">{(subtotal ?? 0).toLocaleString()}</span>
        </div>
      )}

      {/* --- insurances があれば表示 --- */}
      {showInsurances &&
        insurances.map((fee, index) => {
          // 配列の index に応じてラベルを切り替える
          let label = insuranceLabels[index];
          if (!label) {
            // 3番目以降があれば、その他費用として表示
            label = lang === 'ja' ? 'その他費用' : 'Other Fee';
          }

          return (
            <div className="grid grid-cols-3 mb-1" key={index}>
              <span>{label}:</span>
              <span className="text-center">¥</span>
              <span className="text-right">{fee.toLocaleString()}</span>
            </div>
          );
        })}

      {/* --- Grand Total（合計） --- */}
      <div className="border-t border-black grid grid-cols-3 mt-2 pt-2 font-bold">
        <span>{grandTotalLabel}:</span>
        <span className="text-center">¥</span>
        <span className="text-right">{grandTotal.toLocaleString()}</span>
      </div>
    </div>
  );
};
